import { render, staticRenderFns } from "./ReserveChannelSummary.vue?vue&type=template&id=67f582a1&scoped=true"
import script from "./ReserveChannelSummary.vue?vue&type=script&lang=js"
export * from "./ReserveChannelSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f582a1",
  null
  
)

export default component.exports